import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from '@material-ui/core';

/**
 * Shown in place of a report whose filters have been changed since it was run.
 *
 * The report is still in the store — this only covers it — so Cancel puts it straight back
 * along with the filters that produced it. Used by both the A-F page and Flight Plan, which
 * share a filter bar but keep their report payloads in separate stores.
 */
const StaleReportNotice = ({ onCancel }) => (
  <Grid container direction="column" alignItems="center" style={{ padding: '48px 16px', textAlign: 'center' }}>
    <Typography variant="subtitle1" gutterBottom>
      Filters changed — click Get Report
    </Typography>
    <Typography variant="caption" style={{ maxWidth: 520, marginBottom: 16 }}>
      The report below was run with different filters, so it is hidden to avoid reading it as if it matched. Run it
      again, or cancel to bring back the previous report and its filters.
    </Typography>
    <Button onClick={onCancel} color="primary" variant="outlined" size="small">
      Cancel
    </Button>
  </Grid>
);

StaleReportNotice.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default StaleReportNotice;
